import {AcademyData, AccessTokenKey, RefreshTokenKey} from "@/constants/constants";


export function clearTokens() {
    localStorage.removeItem(AccessTokenKey)
    localStorage.removeItem(RefreshTokenKey)
    sessionStorage.removeItem(AccessTokenKey)
    sessionStorage.removeItem(RefreshTokenKey)
    sessionStorage.removeItem(RefreshTokenKey)
    localStorage.removeItem(AcademyData)
}

export function saveTokensChild({accessToken, refreshToken, rememberMe = false}) {


    if (accessToken) {
        if (rememberMe) {
            localStorage.setItem(AccessTokenKey, accessToken)
        } else {
            sessionStorage.setItem(AccessTokenKey, accessToken)
        }
    }
    if (refreshToken) {
        if (rememberMe) {
            localStorage.setItem(RefreshTokenKey, refreshToken)
        } else {
            sessionStorage.setItem(RefreshTokenKey, refreshToken)
        }
    }
}


export function saveTokens({accessToken, refreshToken, rememberMe = false}) {
    clearTokens()

    if (accessToken) {
        if (rememberMe) {
            localStorage.setItem(AccessTokenKey, accessToken)
        } else {
            sessionStorage.setItem(AccessTokenKey, accessToken)
        }
    }
    if (refreshToken) {
        if (rememberMe) {
            localStorage.setItem(RefreshTokenKey, refreshToken)
        } else {
            sessionStorage.setItem(RefreshTokenKey, refreshToken)
        }
    }
}

/**
 * @returns {string|null}
 */
export function getAccessToken() {
    return localStorage.getItem(AccessTokenKey) || sessionStorage.getItem(AccessTokenKey)
}

/**
 * @returns {string|null}
 */
export function getRefreshToken() {
    return localStorage.getItem(RefreshTokenKey) || sessionStorage.getItem(RefreshTokenKey)
}

/**
 */
export function redirectToHome() {
    window.location.href = '/'
}

export function saveTokensAndRedirect({accessToken, refreshToken, rememberMe = false}) {
    saveTokens({accessToken, refreshToken, rememberMe})
    redirectToHome()
}

/**
 */
export function clearTokensAndRedirect() {
    clearTokens()
    if (checkIsLBA()) {
        rememberLBA()
    }
    redirectToHome()
}


export function prepareLBA() {
    localStorage.setItem('LBA-accessToken', localStorage.getItem('accessToken'));
    localStorage.setItem('LBA-academyData', localStorage.getItem('academyData'));
    localStorage.setItem('LBA-auth', localStorage.getItem('auth'));
}


export function rememberLBA() {
    localStorage.setItem('accessToken', localStorage.getItem('LBA-accessToken'));
    localStorage.setItem('academyData', localStorage.getItem('LBA-academyData'));
    localStorage.setItem('auth', localStorage.getItem('LBA-auth'));
    localStorage.removeItem('LBA-accessToken');
    localStorage.removeItem('LBA-academyData');
    localStorage.removeItem('LBA-auth');
}


export function checkIsLBA() {
    if (localStorage.getItem('LBA-accessToken') && localStorage.getItem('LBA-academyData')) {
        return true;
    }
    return false;
}
